import './FunFactItem.css';
import React, { useEffect, useRef } from 'react';
import { canUseDOM, get, injectImageResolution } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { Text, Image } from '@sitecore-jss/sitecore-jss-react';
import LazyPicture from '../atoms/LazyPicture';
import Video from '../atoms/Video';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { convertToAnalyticObject } from '../../utils/analytics';
export var FunFactItem = function FunFactItem(_ref) {
  var fields = _ref.fields,
    inView = _ref.inView,
    _ref$index = _ref.index,
    index = _ref$index === void 0 ? 0 : _ref$index,
    titleContainer = _ref.titleContainer,
    showNumber = _ref.showNumber,
    params = _ref.params,
    _ref$oneItem = _ref.oneItem,
    oneItem = _ref$oneItem === void 0 ? true : _ref$oneItem;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var itemWrapperRef = useRef(null);
  useEffect(function () {
    if (canUseDOM) {
      if (itemWrapperRef.current) {
        if (itemWrapperRef.current.querySelector('.facts__number') !== null) {
          itemWrapperRef.current.querySelector('.facts__number').style.backgroundImage = "url(".concat(imageSrc, ")");
        }
      }
    }
  }, []);
  if (!fields) {
    console.warn('FunFactsItem component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [FunFactsItem component is empty: please provide data source]");
    }
    return null;
  }
  var item = get(fields, 'data.item');
  var hasImageSrc = Boolean(get(item, 'media.jss.value.src'));
  var imageSrc = get(item, 'media.jss.value.src');
  var imageAlt = get(item, 'media.jss.value.alt');
  var videoSrc = get(item, 'video.jss.value.href');
  var videoType = get(item, 'video.jss.value.linktype');
  var videoName = get(item, 'name');
  var description = get(item, 'description.jss');
  var title = get(item, 'title.jss');
  var showNumberCheck = get(showNumber, 'value');
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var renderImage = function renderImage() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, hasImageSrc && /*#__PURE__*/React.createElement(LazyPicture, {
      className: "facts__image-box"
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width:768px)",
      srcSet: "".concat(!oneItem ? injectImageResolution(imageSrc, 340, 255) : injectImageResolution(imageSrc, 460, 340))
    }), /*#__PURE__*/React.createElement("img", {
      src: "".concat(injectImageResolution(imageSrc, 325, 245)),
      alt: imageAlt,
      className: "facts__image"
    })), videoSrc && videoType && /*#__PURE__*/React.createElement(Video, {
      buttonTopAlignment: true,
      className: "media-wrapper__video ",
      videoSrc: videoSrc,
      videoType: videoType,
      loop: true,
      click: function click(e) {
        tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['videoAnalytics'], params.params), [e, videoName]);
      }
    }));
  };
  var renderVideoImage = function renderVideoImage(isVideoExist) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, hasImageSrc && /*#__PURE__*/React.createElement("div", {
      className: "facts__number",
      onClick: function onClick() {
        isVideoExist && tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['videoAnalytics'], params.params), ['Play', videoName]);
      },
      "data-title": imageAlt
    }, "".concat((index < 9 ? '0' : '') + (index + 1))));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    ref: itemWrapperRef,
    className: "facts__block m21-fun-fact-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 d-block d-md-none"
  }, titleContainer && /*#__PURE__*/React.createElement("h4", {
    className: "facts__text-1"
  }, titleContainer)), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4 ".concat(showNumberCheck === true ? 'col-xl-3' : oneItem ? 'col-xl-4' : 'col-xl-3')
  }, /*#__PURE__*/React.createElement("div", {
    className: oneItem ? 'facts__image-block-one' : 'facts__image-block'
  }, !pageEditing ? showNumberCheck === true ? /*#__PURE__*/React.createElement("div", {
    className: "facts__number-container"
  }, renderVideoImage(!!videoSrc)) : renderImage() : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", null, "Numbers will show in preview mode "), /*#__PURE__*/React.createElement(Image, {
    editable: true,
    field: fields.data.item.media.jss
  })))), /*#__PURE__*/React.createElement("div", {
    className: showNumberCheck === true ? '' : 'col-md-1'
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6 ".concat(showNumberCheck === true ? 'col-xl-7' : 'col-xl-6')
  }, /*#__PURE__*/React.createElement("div", {
    className: "facts__info-cnt"
  }, titleContainer && /*#__PURE__*/React.createElement("h3", {
    className: "facts__text-1 d-none d-md-block"
  }, titleContainer), /*#__PURE__*/React.createElement("div", {
    className: "facts__title"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "",
    field: title
  })), /*#__PURE__*/React.createElement("div", {
    className: "facts__info"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "",
    field: description
  }))))))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
export var commonStyles = "cvfmlpn";
export var ltrStyles = "l18smtls";
export var rtlStyles = "rl5nnk2";
export default FunFactItem;